import { useEffect } from 'react';
import MarketCTA from '@/components/MarketCTA';

export default function MarketPage() {
  useEffect(() => {
    document.title = 'JOIN THE TOONVERSE — ARC TOONS';
  }, []);

  return <MarketCTA />;
}
